import 'v-slick-carousel/style.css';
import { VSlickCarousel } from 'v-slick-carousel';
import ShiftDigitalContainer from '../../Events/ShiftDigital/ShiftDigitalContainer';
import { SHIFT_DIGITAL_CORPORATE_CELL_LOCATION } from '@/js/services/ShiftDigital/ShiftDigitalConstants';
import SubaruFlexSpaceBanner from '../SubaruFlexSpaceBanner/SubaruFlexSpaceBanner.vue';
import { STATIC_IMAGE_PATH } from '@/js/constants/constants';
import { getAspectRatioHeight } from '../../../../js/services/CommonUtility';
export default {
  data() {
    return {
      imageDimensions: { width: '', height: '' },
      rightArrow: '',
      leftArrow: '',
      gallery: [
        {
          image: `${STATIC_IMAGE_PATH}oem/subaru/common/Outback_CorpCell_387x210-july.jpg`,
          linkType: 'Outback',
          path: window.baseUrl + '/global-incentives/index',
          altText: 'Outback 2025',
        },
        {
          image: `${STATIC_IMAGE_PATH}oem/subaru/common/Crosstrek_CorpCell_387x210-july.jpg`,
          linkType: 'Crosstrek',
          path: window.baseUrl + '/global-incentives/index',
          altText: 'Crosstrek',
        },
        {
          image: `${STATIC_IMAGE_PATH}oem/subaru/common/Forester_Corp_Cell-387x210-july.jpg`,
          linkType: 'Forester ',
          path: window.baseUrl + '/global-incentives/index',
          altText: 'Forester 2025 ',
        },
        {
          image: `${STATIC_IMAGE_PATH}oem/subaru/common/Solterra_CorpCell_387x210-july.jpg`,
          linkType: 'Solterra',
          path: window.baseUrl + '/global-incentives/index',
          altText: 'Solterra 2025',
        },
        {
          image: `${STATIC_IMAGE_PATH}oem/subaru/common/ForesterHybrid_CorpCell_387x210-july.jpg`,
          linkType: 'Forester Hybrid',
          path: window.baseUrl + '/subaru-forester-hybrid-launch',
          altText: 'Forester Hybrid',
        },
        {
          image: `${STATIC_IMAGE_PATH}oem/subaru/common/JD_Power_CC_387x210-july.jpg`,
          linkType: 'JD Power',
          path: window.baseUrl + '/subaru-awards',
          altText: 'Consumer Reports 2025',
        },
      ],
      slickOptions: {
        dots: false,
        infinite: true,
        infiniteLoopOnEdge: true,
        groupsToShow: 3,
        groupsToScroll: 1,
        arrows: false,
        responsive: [
          {
            breakpoint: 1441,
            settings: {
              groupsToShow: 3,
              groupsToScroll: 1,
              dots: false,
              infinite: true,
              infiniteLoopOnEdge: true,
              arrows: true,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              groupsToShow: 3,
              groupsToScroll: 3,
              dots: false,
              infinite: true,
              infiniteLoopOnEdge: true,
              arrows: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              groupsToShow: 2,
              groupsToScroll: 2,
              dots: false,
              infinite: true,
              infiniteLoopOnEdge: true,
              slidesPerGroup: 1,
              arrows: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              groupsToShow: 2,
              groupsToScroll: 2,
              dots: false,
              infinite: true,
              infiniteLoopOnEdge: true,
              slidesPerGroup: 1,
              arrows: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              groupsToShow: 1,
              groupsToScroll: 1,
              dots: false,
              infinite: true,
              infiniteLoopOnEdge: true,
              slidesPerGroup: 1,
              arrows: true,
            },
          },
        ],
      },
      isLandingPage: window.location.pathname === '/',
    };
  },
  mounted() {
    try {
      const nextArrow = document.querySelector('.v-slick-arrow.next');
      const prevArrow = document.querySelector('.v-slick-arrow.prev');

      if (nextArrow) {
        nextArrow.style = 'visibility:hidden;';
        this.rightArrow = nextArrow;
      } else {
        console.warn('Next arrow element not found.');
      }

      if (prevArrow) {
        prevArrow.style = 'visibility:hidden;';
        this.leftArrow = prevArrow;
      } else {
        console.warn('Previous arrow element not found.');
      }
    } catch (error) {
      console.error('Error in mounted lifecycle hook:', error);
    }
  },
  components: {
    SubaruFlexSpaceBanner,
    VSlickCarousel,
  },
  methods: {
    rightArrowClick() {
      try {
        if (this.rightArrow) {
          this.rightArrow.click();
        } else {
          console.warn('Right arrow element is not available.');
        }
      } catch (error) {
        console.error('Error in testing method:', error);
      }
    },
    leftArrowClick() {
      try {
        if (this.leftArrow) {
          this.leftArrow.click();
        } else {
          console.warn('Right arrow element is not available.');
        }
      } catch (error) {
        console.error('Error in testing method:', error);
      }
    },
    onCorporateCellClick(item) {
      let shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
      let location = SHIFT_DIGITAL_CORPORATE_CELL_LOCATION;
      // checking ==> if location available in a team
      if (item?.location) {
        location = item?.location;
      }
      if (shiftDigital?.linkClick) {
        shiftDigital.linkClick(location, item.linkType);
      }
      setTimeout(() => {
        if (item.path) {
          window.location.href = item.path;
        }
      }, 500);
    },
  },
  created() {
    let windowWidth = +window.innerWidth;
    if (windowWidth <= 700) {
      this.imageDimensions.width = +window.innerWidth;
      this.imageDimensions.height = getAspectRatioHeight(+window.innerWidth, 387, 210);
    }
  },
};
